import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/exceptions")({
  staticData: { breadcrumb: "Exceptions" },
});
